import { WordService } from "./WordService";
import { SupabaseWordService } from "./supabase/SupabaseWordService";
import { SettingsState } from "../features/settings/settingsSlice";
import { FirebaseWordService } from ".";

export type WordServiceType = "supabase" | "firebase";

export interface WordServiceFactoryOptions {
  type: WordServiceType;
  settings?: SettingsState;
}

/**
 * Factory class for creating WordService instances
 * This allows switching between different implementations
 */
export class WordServiceFactory {
  static create(options: WordServiceFactoryOptions): WordService {
    switch (options.type) {
      case "supabase":
        return new SupabaseWordService();

      case "firebase":
        return new FirebaseWordService();

      default:
        throw new Error(`Unsupported WordService type: ${options.type}`);
    }
  }
}

/**
 * Example usage of the factory pattern with WordService
 */
export const createWordService = {
  supabase: (settings: SettingsState): WordService =>
    WordServiceFactory.create({ type: "supabase", settings }),

  firebase: (settings: SettingsState): WordService =>
    WordServiceFactory.create({ type: "firebase", settings }),

  createDefault: (settings: SettingsState): WordService =>
    WordServiceFactory.create({ type: "supabase", settings }),
};
